import Service from "../../service";

const Transport = {
    getTransportation(page) {
        return Service.get("/transportation?page="+page)
    },
    getAllTransportation(){
        return Service.get("/get_all_transportation");
    },
    getTransportationShow(page) {
        return Service.get("/transportation?page="+page);
    },
    getTransportationList({ page }) {
        return Service.get("/transportation")
    },
    showTransportation(id) {
        return Service.get("/transportation/" + id)
    },
    updateTransportation(id, data) {
        return Service.put("/transportation/" + id, data)
    },
    createTransportation(data) {
        return Service.post("/transportation", data)
    },
    deleteTransportation(id) {
        return Service.delete("/transportation/" + id)
    },
    searchTransportation(data){
        return Service.post('/transportation_search',data);
    },
    updateTransportationFee(data){
        return Service.post('update_transportation_fee',data);
    }
};
export default Transport;
